import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, pairwise } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationTrackingService {
  private readonly loginRoutePatterns = ['/auth/login', `/pwa/login`, `/pwa/login/login-form`];

  private readonly isFromLoginSubject = new BehaviorSubject<boolean>(false);

  readonly isFromLogin$ = this.isFromLoginSubject.asObservable();

  constructor(private router: Router) {
    this.initializeTracking();
  }

  private initializeTracking(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        pairwise(), // Get previous and current navigation events
      )
      .subscribe(([previousEvent, currentEvent]: [NavigationEnd, NavigationEnd]) => {
        const previousUrl = previousEvent.urlAfterRedirects || previousEvent.url;
        const currentUrl = currentEvent.urlAfterRedirects || currentEvent.url;

        const wasFromLogin = this.isLoginRoute(previousUrl) && !this.isLoginRoute(currentUrl);
        this.isFromLoginSubject.next(wasFromLogin);
      });
  }

  private isLoginRoute(url: string): boolean {
    if (!url) {
      return false;
    }
    return this.loginRoutePatterns.some(pattern => url.includes(pattern));
  }

  markNavigationFromLogin(): void {
    this.isFromLoginSubject.next(true);
    setTimeout(() => {
      this.isFromLoginSubject.next(false);
    }, 500);
  }

  resetNavigationFromLogin(): void {
    this.isFromLoginSubject.next(false);
  }
}
